"use strict";

const InitializeBannerProductSecondary = () => {
    const $btnModalBannerProductSecondary      = $(".js-btn-modal-banner-product-secondary");
    const $modalBannerProductSecondary         = $(".js-banner-product-secondary");
    const $btnCloseModalBannerProductSecondary = $(".js-close-button");

    const listenEvents = () => {
        $btnModalBannerProductSecondary.on("click", (e) => {
            e.preventDefault();

            $(e.currentTarget).next().addClass("show");
        });

        $btnCloseModalBannerProductSecondary.on("click", (e) => {
            e.preventDefault();

            $modalBannerProductSecondary.closest(".js-banner-product-secondary").removeClass("show");
        });
    };

    const init = () => {
        listenEvents();
    };

    init();
};


export default InitializeBannerProductSecondary;
